/** Live occupancy status for desk spots and motion rooms in the live floor plan view. */
export type LiveOccupancyStatus = 'available' | 'occupied' | 'unknown';

export const LIVE_OCC_COLORS: Record<LiveOccupancyStatus, string> = {
  available: '#10B981',
  occupied: '#EB860A',
  unknown: '#8C8C8C',
};

// Sensor3p SVG filter IDs for live occupancy coloring.
export const SENSOR3P_LIVE_FILTER_ID: Record<LiveOccupancyStatus, string> = {
  available: 'sensor3p-live-available',
  occupied: 'sensor3p-live-occupied',
  unknown: 'sensor3p-live-unknown',
};

// Spot SVG filter IDs for live occupancy coloring.
export const SPOT_LIVE_FILTER_ID: Record<LiveOccupancyStatus, string> = {
  available: 'spot-live-available',
  occupied: 'spot-live-occupied',
  unknown: 'spot-live-unknown',
};
